import React from 'react';
import MatchList from '../common/MatchList';

export default function LiveMatches(props) {
  return (
    <MatchList
      {...props}
      subtitle="Live now"
      emptyMessage="No matches in play right now."
    />
  );
}
